import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import BenchmarkingQHPService from "@app/overviews/network-benchmarking-dashboard/benchmarkingQHPService";
import { BenchmarkingFilterData } from "@app/overviews/network-benchmarking-dashboard/filters/shared/BenchmarkingFilterData";

export interface QHPPrimaryFiltersResult {
  isLoading: boolean;
  primaryFilterData: BenchmarkingFilterData | undefined;
}

export const QHP_PRIMARY_FILTERS_QUERY_KEY_PREFIX = "qhp-primary-filters";

export const useQHPPrimaryFilters = (clientId: number | undefined, enabled: boolean): QHPPrimaryFiltersResult => {
  const benchmarkingQHPService = useMemo(() => new BenchmarkingQHPService(), []);

  const queryResult = useQuery<BenchmarkingFilterData>({
    enabled,
    queryFn: ({ signal }) => benchmarkingQHPService.getBenchmarkingPrimaryFilterData(signal),
    queryKey: [QHP_PRIMARY_FILTERS_QUERY_KEY_PREFIX, clientId],
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000,
  });

  return {
    isLoading: queryResult.isFetching,
    primaryFilterData: queryResult.data,
  };
}

export default useQHPPrimaryFilters;
